<template>
    <div style="width: 100%">
        <canvas id="chart-aplication-user-role"></canvas>
    </div>
</template>

<script>
import Chart from "chart.js";
import _service from "@/services/userService";

export default {
    name: "PlanetChart",
    data() {
        return {
            ChartData: null,
            labelChart: [],
            valueChart: [],
        };
    },
    async mounted() {
        const data = await _service.getResumenUserByRole();
        var datos = data.data;
        console.log(datos);
        var object = function (key, text) {
            this.key = key;
            this.text = text;
        };

        var objArray = [];
        objArray[0] = new object("Administrador");
        objArray[1] = new object("Delivery");
        objArray[2] = new object("Verificador");
        objArray[3] = new object("Empacador");

        var keys = objArray.map(function (o) {
            return o.key;
        });

        this.labelChart = keys; // ["Activo", "En proceso", "Cancelada", "Completada"];
        this.valueChart = [
            datos["usersAdministrator"],
            datos["usersDelivery"],
            datos["usersChecker"],
            datos["usersPacker"],
        ];
        const ChartData = {
            type: "bar",
            data: {
                labels: this.labelChart,
                datasets: [
                    {
                        label: "Resumen de Roles por Usuarios",
                        data: this.valueChart,
                        backgroundColor: "#3F69A6",
                        borderColor: "#3F69A6",
                        borderWidth: 3,
                    },
                ],
            },
            options: {
                responsive: true,
                lineTension: 1,
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                padding: 25,
                            },
                        },
                    ],
                },
            },
        };

        this.ChartData = ChartData;

        const ctx = document.getElementById("chart-aplication-user-role");
        new Chart(ctx, this.ChartData);
    },
};
</script>
